import 'jquery-ui/ui/widgets/datepicker';
import moment from 'moment';

import Base from 'app/views/base';

import { formatIsoDate } from 'utils/dates';

import tmpl from 'templates/datepickers_for_range';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ minDate }) {
    this.minDate = minDate;
  },

  context() {
    return {
      start_date: formatIsoDate(this.model.get('startDatetime')),
      end_date: formatIsoDate(this.model.get('endDatetime')),
    };
  },

  afterRender() {
    this.setupDatepickers();
  },

  setupDatepickers() {
    const defaults = {
      maxDate: formatIsoDate(moment.utc().startOf('day')),
      dateFormat: 'yy-mm-dd',
      yearRange: 'c-3:c+1',
      minDate: this.minDate,
      changeMonth: true,
      changeYear: true,
      numberOfMonths: 1,
    };

    const self = this;
    this.$('#start_datepicker').datepicker({
      ...defaults,
      onClose(selectedDate) {
        self.changeDate('startDatetime', self.momentFromDatepickerValue(selectedDate));
      },
    });

    this.$('#end_datepicker').datepicker({
      ...defaults,
      onClose(selectedDate) {
        self.changeDate('endDatetime', self.momentFromDatepickerValue(selectedDate));
      },
    });
  },

  changeDate(field, selectedDate) {
    if (field === 'startDatetime') {
      this.$('#end_datepicker').datepicker('option', 'minDate', formatIsoDate(selectedDate));
    } else if (field === 'endDatetime') {
      this.$('#start_datepicker').datepicker('option', 'maxDate', formatIsoDate(selectedDate));
    }
    this.model.set(field, selectedDate);
  },

  momentFromDatepickerValue(datepickerValue) {
    /** datepickerValue is in YYYY-MM-DD format. moment(datepickerValue) will create a
     moment at the start of that day, local time. we then convert that to utc, and get
     the start of that day, which is more lenient than is accurate. */
    return moment(datepickerValue).utc().startOf('day');
  },
});



// WEBPACK FOOTER //
// ./app/views/datepicker_range_view.js